module.exports = __webpack_public_path__ + "img/logo-min.ee7dacb4.svg";